{
  "home": {
    "title": "Benvenuta su",
    "subtitle": "Gestione smart dei tuoi matrimoni e contratti.",
    "go": "Inizia ora",
    "next_wedding": "Prossimo evento",
    "next_test": "Prossima prova",
    "no_wedding": "Nessun evento in programma",
    "no_test": "Nessuna prova in programma",
    "stats": {
      "weddings": "Eventi",
      "contracts": "Contratti"
    },
    "eyebrow": "Per makeup artist e parrucchieri",
    "hero_title_1": "Il backstage perfetto",
    "hero_title_2": "di ogni matrimonio.",
    "hero_subtitle": "agenda orga-nized, team synchro-nized: gestisci clienti, contratti e appuntamenti senza perdere tempo.",
    "add": "Aggiungi",
    "features": {
      "contracts_title": "Contratti in un click",
      "contracts_desc": "Genera contratti professionali personalizzati per ogni cliente, pronti da firmare.",
      "calendar_title": "Calendario sempre aggiornato",
      "calendar_desc": "Matrimoni e prove in un unico calendario. Niente sovrapposizioni, niente dimenticanze.",
      "clients_title": "Ogni cliente, al suo posto",
      "clients_desc": "Schede complete per ogni sposa: servizi, note e documenti sempre a portata di mano."
    },
    "create_event": "Crea evento",
    "dashboard": {
      "hello": "Ciao",
      "overview": "Ecco la tua panoramica",
      "upcoming": "Eventi in arrivo",
      "to_generate": "Contratti da generare",
      "open_balance": "Saldo aperto",
      "to_collect": "da incassare",
      "quick_actions": "Azioni rapide",
      "new_event": "Nuovo evento",
      "open": "Apri",
      "agenda": "Prossimi eventi",
      "todo": "Cose da fare",
      "all_done": "Tutto in ordine",
      "to_sign": "Contratti da firmare",
      "deposits_to_collect": "Acconti da incassare",
      "next_trial": "Prossima prova",
      "next_inspection": "Prossimo sopralluogo",
      "no_trial": "Niente in programma",
      "year_summary": "Riepilogo {{year}}",
      "events": "Eventi",
      "signed": "Contratti firmati",
      "signed_tooltip": "Eventi con la firma del contratto già raccolta.",
      "expected": "Entrate previste",
      "expected_tooltip": "Valore totale di tutti gli eventi dell'anno, non solo quanto hai già incassato: include anche acconti e saldi ancora da ricevere.",
      "collected": "Incassato",
      "travel_title": "Trasferte",
      "km_year": "Km nel {{year}}",
      "km_upcoming": "Km da percorrere",
      "travel_cost_year": "Totale trasferte",
      "by_city": "Per città",
      "other_cities": "+{{count}} altre città",
      "month_map": "Mappa del mese",
      "st_to_generate": "Da generare",
      "st_to_sign": "Da firmare",
      "st_deposit": "Acconto",
      "st_ok": "Tutto ok",
      "see_all": "Vedi tutti",
      "band_future": "In arrivo",
      "band_present": "In primo piano",
      "band_past": "Il tuo percorso",
      "quotes_sent": "Preventivi inviati",
      "quote_expires": "Preventivo, scade il {{date}}",
      "signature_expires": "Firma, scade il {{date}}",
      "events_done": "Eventi svolti",
      "collected_tooltip": "Acconti e saldi che hai segnato come pagati, trasferte escluse.",
      "at_time": "ore {{time}}",
      "pro_teaser_title": "Statistiche e mappe",
      "pro_teaser_text": "Trasferte e mappa degli eventi sono disponibili con il piano <strong>Pro</strong>.",
      "pro_teaser_cta": "Scopri Pro",
      "watch_title": "Da tenere d'occhio",
      "watch_empty": "Tutto tranquillo per i prossimi {{days}} giorni",
      "countdown_today": "oggi",
      "countdown_tomorrow": "domani",
      "countdown_days": "tra {{n}} giorni",
      "events_done_tooltip": "Eventi confermati con data già passata. I preventivi non accettati non sono contati."
    }
  },
  "navbar": {
    "home": "Home",
    "wedding": "Eventi",
    "contracts": "Contratti",
    "profile": "Profilo",
    "settings": "Impostazioni",
    "calendar": "Calendario",
    "feedback": "Feedback",
    "notifications": "Notifiche",
    "mark_all_read": "Segna tutte lette",
    "no_notifications": "Nessuna notifica",
    "logout": "Esci",
    "collaborations": "Rubrica",
    "pricelist": "Listino",
    "hello": "Ciao",
    "more": "Altro",
    "statistics": "Statistiche"
  },
  "login": {
    "title": "Accedi al tuo account",
    "username": "Username",
    "password": "Password",
    "submit": "Accedi",
    "remember": "Ricordami",
    "noAccount": "Non hai un account?",
    "register": "Registrati",
    "error": "Credenziali errate",
    "username_or_email": "Email o username",
    "resend_confirmation_link": "Invia di nuovo l'email di conferma",
    "tagline": "Meno scartoffie, più tempo per il tuo mestiere: Nyzed tiene tutto sotto controllo, dal primo contratto all'ultimo ritocco.",
    "feature1_label": "Orga-nized",
    "feature1": "contratti in un click",
    "feature2_label": "Synchro-nized",
    "feature2": "calendario sempre aggiornato",
    "feature3_label": "Recog-nized",
    "feature3": "schede cliente complete",
    "or_divider": "oppure",
    "forgot_password": "Password dimenticata?"
  },
  "register": {
    "title": "Crea il tuo account",
    "name": "Nome",
    "lastname": "Cognome",
    "username": "Username",
    "email": "Email",
    "password": "Password",
    "submit": "Registrati",
    "hasAccount": "Hai già un account?",
    "login": "Accedi",
    "pending": "Registrazione completata! Il tuo account è in attesa di approvazione.",
    "tagline": "Il tuo prossimo matrimonio inizia da qui. Crea il tuo account gratuito e lascia che sia Nyzed a pensare all'organizzazione.",
    "feature1_label": "Orga-nized",
    "feature1": "contratti in un click",
    "feature2_label": "Synchro-nized",
    "feature2": "calendario sempre aggiornato",
    "feature3_label": "Recog-nized",
    "feature3": "schede cliente complete",
    "activity_label": "Di cosa ti occupi?",
    "trucco": "Trucco",
    "capelli": "Capelli",
    "fotografia": "Fotografia",
    "data_label": "I tuoi dati",
    "confirm_password": "Conferma password",
    "email_invalid": "Inserisci un'email valida",
    "check_email_title": "Controlla la tua email",
    "check_email_text": "Ti abbiamo inviato un link per confermare il tuo account. Aprilo per poter accedere.",
    "check_email_hint": "Controlla anche la cartella spam.",
    "or_divider": "oppure"
  },
  "confirm_email": {
    "tagline": "Un ultimo passo prima di iniziare a usare Nyzed.",
    "confirming_title": "Conferma in corso",
    "confirming_text": "Stiamo confermando la tua email, un istante...",
    "success_title": "Email confermata",
    "success_text": "Il tuo account è attivo. Verrai reindirizzata al login tra qualche secondo.",
    "invalid_title": "Link non valido",
    "resend_intro": "Il link non è valido o è scaduto. Inserisci la tua email per riceverne uno nuovo.",
    "resend_placeholder": "La tua email",
    "resend_btn": "Invia nuovo link",
    "resend_loading": "Invio in corso...",
    "resend_sent": "Se l'indirizzo è registrato e non ancora confermato, riceverai un nuovo link a breve.",
    "back_to_login": "← Torna al login"
  },
  "weddings": {
    "title": "Eventi",
    "add": "Nuovo evento",
    "filters": {
      "all": "Tutti",
      "upcoming": "Futuri",
      "past": "Passati",
      "from": "Dal",
      "to": "Al"
    },
    "search": "Cerca per nome o location...",
    "card": {
      "date": "Data",
      "location": "Location",
      "view": "Visualizza"
    },
    "empty": "Nessun evento trovato.",
    "title_sub": "in agenda",
    "next": "Prossimo evento",
    "open_card": "Apri scheda →",
    "view_list": "Lista",
    "view_map": "Mappa",
    "map_empty": "Nessun evento con indirizzo da mostrare sulla mappa",
    "countdown": "giorni all'evento",
    "search_bride": "Cerca cliente...",
    "collaborations": "Collaborazioni",
    "collaboration": "Collaborazione",
    "open": "Apri →",
    "filters_toggle": "Filtri",
    "sort": {
      "label": "Ordina",
      "date": "Per data",
      "created": "Ultimi inseriti"
    }
  },
  "contracts": {
    "title": "Contratti",
    "empty": "Nessun contratto trovato.",
    "generate": "Genera contratto",
    "download": "Scarica",
    "view": "Visualizza",
    "regenerate": "Rigenera",
    "generated": "Contratto generato",
    "not_generated": "Non generato",
    "title_sub": "generati",
    "count": "contratti",
    "total": "Totale",
    "this_year": "Quest'anno",
    "this_month": "Questo mese",
    "search": "Cerca per nome...",
    "all_years": "Tutti",
    "card_link": "Scheda",
    "tab_generated": "Contratti generati",
    "tab_settings": "Impostazioni contratto",
    "status": {
      "signed": "Firmato",
      "waiting": "In attesa di firma",
      "todo": "Da inviare per la firma"
    },
    "regenerate_title": "Rigenera contratto",
    "regenerate_text": "Rigenera il contratto per {{name}}? La versione attuale verrà archiviata nello storico.",
    "load_error": "Dati non caricati correttamente",
    "empty_cta": "Vai agli eventi"
  },
  "calendar": {
    "title": "Calendario",
    "title_full": "Calendario Eventi",
    "legend": {
      "wedding": "Matrimonio",
      "test": "Prova",
      "hint": "Tocca per mostrare/nascondere",
      "sopralluogo": "Sopralluogo"
    },
    "kpi": {
      "month_count": "{{count}} eventi questo mese",
      "next_today": "Prossimo evento: oggi",
      "next_tomorrow": "Prossimo evento: domani",
      "next_in_days": "Prossimo evento tra {{count}} giorni",
      "next_none": "Nessun evento in programma"
    },
    "quick_create": {
      "placeholder": "Nome cliente",
      "cancel": "Annulla",
      "create": "Crea evento"
    },
    "reminders": {
      "title": "Promemoria",
      "empty": "Nessun promemoria",
      "placeholder": "Aggiungi un promemoria...",
      "remove": "Rimuovi",
      "add": "Aggiungi promemoria"
    },
    "months": [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ],
    "days": [
      "Lun",
      "Mar",
      "Mer",
      "Gio",
      "Ven",
      "Sab",
      "Dom"
    ],
    "no_events": "Nessun evento",
    "weather": {
      "clear": "Sole pieno! Occhiali da sole e crema solare in valigia",
      "cloudy": "Un po' di nuvole, ma niente di cui preoccuparsi",
      "fog": "Nebbiolina in arrivo... parti con qualche minuto di vantaggio, non si sa mai!",
      "drizzle": "Quattro gocce in arrivo: un ombrellino chic è la mossa giusta",
      "rain": "Si preannuncia pioggia vera: ombrello grande e piano B pronto!",
      "snow": "Neve all'orizzonte, meglio partire con calma e stivali comodi",
      "storm": "Temporale in arrivo: tieni pronto il piano B al coperto, meglio prevenire!"
    },
    "modal": {
      "date": "Data",
      "contract_signed": "Contratto firmato",
      "contract_pending": "Contratto da firmare",
      "deposit_paid": "Acconto pagato",
      "deposit_pending": "Acconto da saldare",
      "open_event": "Apri scheda evento",
      "close": "Chiudi"
    },
    "m": {
      "today": "Oggi",
      "tomorrow": "Domani",
      "prev": "Mese precedente",
      "next": "Mese successivo",
      "month": "Mese",
      "upcoming": "Prossimi",
      "new": "Nuovo",
      "no_events_day": "Nessun evento in questo giorno",
      "no_upcoming": "Nessun evento nei prossimi 90 giorni"
    }
  },
  "profile": {
    "title": "Profilo",
    "tabs": {
      "profile": "Profilo",
      "contract": "Dati Contratto",
      "packages": "Pacchetti",
      "services": "Listino",
      "team": "Accessi team",
      "visibility": "Visibilità",
      "appearance": "Aspetto"
    },
    "theme": {
      "title": "Aspetto",
      "subtitle": "Scegli la palette colori dell'app. Le palette diverse dal Default richiedono il piano Pro o Agency.",
      "default_name": "Nyzed",
      "default_desc": "Identità di brand: arancio e lavanda su blu notte",
      "floreale_name": "Romantico Floreale",
      "floreale_desc": "Palette calda e delicata",
      "caldo_name": "Originale Caldo",
      "caldo_desc": "Toni caldi e avvolgenti",
      "lusso_name": "Lusso Moderno",
      "lusso_desc": "Elegante, minimale, arancio bruciato e viola profondo",
      "botanico_name": "Aurora",
      "botanico_desc": "Arancio vivo e lavanda tenue, luminoso e leggero",
      "scura_name": "Eleganza Scura",
      "scura_desc": "Grigio-blu con arancio e viola, atmosfera sofisticata",
      "mediterraneo_name": "Mediterraneo",
      "mediterraneo_desc": "Terracotta e lavanda, calore mediterraneo",
      "notte_name": "Notte",
      "notte_desc": "Dark mode vera, riposante per gli occhi",
      "alto_contrasto_name": "Alto Contrasto",
      "alto_contrasto_desc": "Massima leggibilità, pensato per l'accessibilità: gratuito"
    },
    "fields": {
      "name": "Nome",
      "lastname": "Cognome",
      "username": "Username",
      "email": "Email",
      "organization": "Studio / Nome attività",
      "activity": "Attività",
      "hair": "Parrucchiera",
      "makeup": "Truccatrice",
      "photo": "Fotografa"
    },
    "password": {
      "current": "Password attuale",
      "new": "Nuova password",
      "confirm": "Conferma password"
    },
    "contract": {
      "title": "Intestazione contratto",
      "address": "Indirizzo",
      "telephone": "Telefono",
      "email": "Email contratto",
      "piva": "P.IVA",
      "template": "Template PDF",
      "signature": "Firma digitale",
      "clear": "Cancella",
      "save_signature": "Salva firma",
      "location_requirements": "Requisiti location (EN)",
      "location_requirements_ita": "Requisiti location (IT)",
      "payment_terms": "Termini di pagamento (EN)",
      "payment_terms_ita": "Termini di pagamento (IT)",
      "cancelation_terms": "Termini di cancellazione (EN)",
      "cancelation_terms_ita": "Termini di cancellazione (IT)"
    },
    "stats": {
      "weddings": "Totale eventi",
      "contracts": "Contratti generati"
    },
    "edit": "Modifica profilo",
    "save": "Salva",
    "cancel": "Annulla",
    "logout": "Esci",
    "change_avatar": "Cambia",
    "weddings_count": "Eventi",
    "contracts_count": "Contratti",
    "default_services": "Servizi di default",
    "edit_profile_btn": "Modifica Profilo",
    "edit_profile_desc": "I tuoi dati personali e professionali: vengono usati in tutta l'app, dalla dashboard al contratto.",
    "logout_btn": "Logout",
    "professional_category_label": "Categoria professionale",
    "operating_area_label": "Zona operativa",
    "operating_area_placeholder": "Es. Toscana, Firenze, Umbria",
    "operating_area_hint": "Le zone in cui lavori, separate da virgola",
    "category_placeholder": "Seleziona categoria",
    "category_other": "Altro",
    "activity_type": "Tipo di attività",
    "trucco": "Trucco",
    "capelli": "Capelli",
    "foto": "Foto",
    "service_hint": "Separati da punto e virgola ( ; )",
    "change_password_label": "Cambia Password",
    "new_password_label": "Nuova Password",
    "confirm_password_label": "Conferma Password",
    "leave_empty": "Lascia vuoto per non cambiare",
    "contract_empty_msg": "Non hai ancora configurato il contratto",
    "default_contract_title": "Il tuo contratto di default",
    "default_contract_desc": "È la base di partenza per ogni nuovo evento. Puoi modificarlo quando vuoi, e per un singolo evento puoi comunque personalizzarlo senza toccare questo modello.",
    "configure_wizard_btn": "✦ Configura con wizard",
    "guided_wizard_btn": "✦ Wizard guidato",
    "free_edit_btn": "Modifica libera",
    "configure_title": "Configura il tuo contratto",
    "configure_desc": "Inserisci i tuoi dati e le clausole per poter generare contratti per le tue spose.",
    "start_config_btn": "Inizia la configurazione",
    "studio_data": "Dati Studio",
    "edit_btn": "Modifica",
    "studio_name_label": "Nome studio / attività",
    "full_name_label": "Nome e cognome",
    "address_label": "Indirizzo",
    "phone_label": "Telefono",
    "piva_label": "P.IVA",
    "travel_rate_label": "Tariffa trasferta (€/km)",
    "travel_rate_hint": "Costo al chilometro per raggiungere la location. Viene moltiplicato per i km andata e ritorno per proporre il costo trasferta di ogni evento (poi modificabile). A titolo indicativo: 0,20–0,50 €/km.",
    "payment_section": "Pagamento",
    "deposit_amount_label": "Importo acconto (€)",
    "deposit_method_q": "Come si paga l'acconto?",
    "deposit_method_label": "Modalità pagamento acconto",
    "cash": "Contanti",
    "transfer": "Bonifico",
    "both": "Entrambi",
    "final_when_q": "Quando si paga il saldo?",
    "wedding_day_opt": "Il giorno dell'evento",
    "wedding_day_short": "Giorno evento",
    "days_before_opt": "Giorni prima",
    "how_many_days_label": "Quanti giorni prima?",
    "preview_clause": "Anteprima clausola",
    "preview_payment": "✦ Anteprima pagamento",
    "preview_location": "✦ Anteprima location",
    "preview_cancellation": "✦ Anteprima cancellazione",
    "preview_generated": "✦ Anteprima clausola generata",
    "location_reqs": "Requisiti Location",
    "work_table": "Tavolo da lavoro",
    "natural_light": "Luce naturale",
    "power_outlet": "Presa elettrica",
    "additional_notes_label": "Testo libero",
    "other_needs": "Altre esigenze?",
    "work_table_full": "Un tavolo da lavoro",
    "natural_light_full": "Luce naturale adeguata",
    "power_outlet_full": "Una presa elettrica",
    "cancellation_section": "Cancellazione",
    "deposit_refundable_q": "L'acconto è rimborsabile in caso di cancellazione?",
    "deposit_refundable_tooltip": "Se scegli \"Non rimborsabile\", l'acconto resta a te anche se il cliente annulla l'evento: è la garanzia che copre il tempo che hai bloccato per lui.",
    "deposit_refundable_short": "L'acconto è rimborsabile?",
    "deposit_refundable_short2": "Acconto rimborsabile?",
    "yes_refundable": "Sì, rimborsabile",
    "yes_short": "Sì",
    "no_refundable": "No, non rimborsabile",
    "no_short": "No",
    "postponement_q": "In caso di rinvio della data?",
    "postponement_tooltip": "Decidi cosa succede all'acconto già versato se la data dell'evento viene spostata: resta valido per la nuova data oppure va restituito al cliente.",
    "postponement_policy_label": "Politica rinvio",
    "transfer_date_opt": "Acconto trasferito alla nuova data",
    "transfer_short": "Trasferito",
    "keep_deposit_opt": "Acconto trattenuto",
    "keep_deposit_short": "Trattenuto",
    "cancellation_notes_label": "Note cancellazione",
    "template_firma": "Template & Firma",
    "template_pdf_label": "Template PDF",
    "preview_template": "Anteprima",
    "preview_template_title": "Anteprima contratto",
    "close": "Chiudi",
    "no_signature": "Nessuna firma caricata",
    "draw_signature": "Disegna qui la tua firma",
    "redraw_signature": "Ridisegna per aggiornare",
    "clear_signature": "Cancella",
    "save_signature_btn": "Salva Firma",
    "free_contract_text": "Testo libero contratto",
    "free_contract_hint": "Scrivi il testo di ogni sezione. Usa le variabili per inserire dati reali al momento della generazione.",
    "save_contract_text_btn": "Salva testo contratto",
    "packages_services": "Pacchetti & Servizi",
    "packages_desc": "Definisci i tuoi pacchetti standard: verranno precaricati ad ogni nuovo matrimonio",
    "no_packages": "Nessun pacchetto ancora. Aggiungine uno!",
    "add_package": "+ Aggiungi pacchetto",
    "show_total_contract": "Mostra totale nel contratto",
    "total_shown": "Il totale dei servizi verrà mostrato nel contratto",
    "total_hidden": "Il totale non verrà mostrato nel contratto",
    "services_list_title": "Listino Servizi",
    "services_list_desc": "Definisci i tuoi servizi singoli: potrai selezionarli per ogni matrimonio",
    "add_service": "+ Aggiungi",
    "no_services": "Nessun servizio ancora",
    "no_services_desc": "Aggiungi i tuoi servizi al listino prezzi.",
    "add_service_btn": "+ Aggiungi servizio",
    "service_discount_name": "Nome dello sconto",
    "service_discount_name_placeholder": "Es. Offerta Tutto Sposi",
    "service_discount_toggle": "Sconto attivo",
    "service_discount_price": "Prezzo scontato",
    "service_discount_until": "Valido fino al",
    "service_discount_badge": "Sconto fino al",
    "service_desc_label": "Descrizione",
    "team_title": "Rubrica collaboratori",
    "team_desc": "I collaboratori fissi che assegni agli eventi. Chi deve entrare nell'app con un proprio accesso si invita da Profilo → Accessi team.",
    "team_add": "+ Aggiungi",
    "team_empty": "Nessun collaboratore ancora",
    "team_empty_desc": "Aggiungi le persone con cui lavori per assegnarle agli eventi.",
    "team_add_btn": "+ Aggiungi collaboratore",
    "team_role_label": "Ruolo",
    "team_notes_label": "Note",
    "available": "Disponibile",
    "not_available": "Non disponibile",
    "wizard_intro_title": "Configuriamo il tuo contratto",
    "wizard_intro_p1": "Questi sono i dati di default del tuo contratto, salvati nel tuo profilo.",
    "wizard_intro_p2": "Potrai comunque modificarli per ogni singolo evento dalla scheda evento.",
    "wizard_intro_start": "Iniziamo",
    "chain_step": "Passo {{n}} di 5",
    "listino_chain_title": "Passo 5 di 5: il tuo listino",
    "listino_chain_text": "Controlla o aggiungi le tue voci di listino, poi passa alla home.",
    "listino_chain_home_btn": "Vai alla Home →",
    "wizard_step0_title": "Chi sei?",
    "wizard_step0_subtitle": "I dati del tuo studio appariranno nell'intestazione del contratto",
    "wizard_step1_title": "Come gestisci i pagamenti?",
    "wizard_step1_subtitle": "Definisci acconto e saldo: verrà generato automaticamente il testo della clausola",
    "wizard_step2_title": "Di cosa hai bisogno sul posto?",
    "wizard_step2_subtitle": "Seleziona i requisiti minimi per poter lavorare",
    "wizard_step3_title": "Cosa succede se si cancella?",
    "wizard_step3_subtitle": "Definisci la tua politica di cancellazione",
    "wizard_step4_title": "Scegli il look del contratto",
    "wizard_step4_subtitle": "Template e firma digitale",
    "wizard_prev": "← Indietro",
    "wizard_next": "Avanti →",
    "wizard_save": "✦ Salva contratto",
    "wizard_cancel": "Annulla",
    "free_edit_title": "Modifica Contratto",
    "studio_name_short": "Nome studio",
    "location_notes_label": "Note location",
    "save_all": "Salva tutto",
    "Template": "Template",
    "final_method_q": "Come si paga il saldo?",
    "package_name_placeholder": "Nome pacchetto",
    "service_name_placeholder": "Nome servizio",
    "price_placeholder": "Prezzo €",
    "service_desc_placeholder": "Es. include prova trucco",
    "team_name_placeholder": "Nome",
    "team_lastname_placeholder": "Cognome",
    "team_email_placeholder": "email@esempio.com",
    "team_notes_placeholder": "Note libere...",
    "location_access_placeholder": "Es. accesso anticipato di 30 minuti...",
    "visibility": {
      "title": "Visibilità sezioni",
      "subtitle": "Scegli quali sezioni degli eventi possono vedere i tuoi collaboratori e il tuo team. Questi sono i valori predefiniti, modificabili per singolo evento.",
      "collaborators": "Collaboratori",
      "team": "Team",
      "save": "Salva visibilità",
      "sections": {
        "event_data": "Dati evento",
        "trial": "Prova / Sopralluogo",
        "photos": "Foto",
        "client": "Cliente",
        "services": "Servizi e costi",
        "participants": "Clienti",
        "contract": "Contratto",
        "documents": "Documenti"
      }
    },
    "iban_label": "IBAN",
    "iban_placeholder": "IT00 A000 0000 0000 0000 0000 000",
    "other_section": "Altro",
    "other_section_tooltip": "Aggiungi una clausola personalizzata: titolo e testo verranno stampati così come li scrivi nel PDF del contratto.",
    "other_title_label": "Titolo",
    "other_title_placeholder": "Es. Clausola aggiuntiva",
    "other_text_label": "Testo libero",
    "listino": {
      "load_error": "Errore nel caricamento del listino",
      "remove_title": "Rimuovi servizio",
      "remove_text": "Sei sicuro di voler rimuovere questo servizio?",
      "discount_invalid": "Con lo sconto attivo servono un prezzo scontato inferiore al prezzo pieno e una data di fine",
      "name_required": "Il nome è obbligatorio",
      "saved": "Listino salvato",
      "save_error": "Salvataggio listino fallito"
    },
    "access": {
      "title": "Accessi team",
      "desc": "Le persone del tuo team che entrano nell'app con un proprio accesso: ricevono una mail per impostare la password e vedono gli eventi a cui le assegni. I collaboratori senza accesso si gestiscono nella Rubrica.",
      "email_placeholder": "email@esempio.com",
      "invite": "Invita",
      "empty": "Nessun accesso al team",
      "empty_desc": "Invita la prima persona inserendo la sua email qui sopra.",
      "active": "Attivo",
      "pending": "In attesa",
      "resend": "Reinvia",
      "remove": "Rimuovi accesso"
    },
    "rubrica": {
      "pro_lock": "Aggiungi collaboratori con il piano Pro.",
      "on_app": "Su Nyzed",
      "invite_app": "Invita su Nyzed",
      "app_user": "Utente Nyzed",
      "desc_short": "Le persone con cui lavori, da assegnare agli eventi. Chi deve entrare nell'app con un proprio accesso va in Accessi team.",
      "add": "Aggiungi collaboratore",
      "name": "Nome",
      "lastname": "Cognome",
      "available_label": "Disponibile per nuovi eventi",
      "load_error": "Errore nel caricamento",
      "invite_sent": "Invito inviato",
      "invite_error": "Invio invito fallito",
      "remove_title": "Rimuovi collaboratore",
      "remove_text": "Vuoi rimuovere questa persona dalla rubrica?",
      "saved": "Salvato",
      "save_error": "Salvataggio fallito",
      "name_required": "Il nome è obbligatorio"
    },
    "logo": {
      "label": "Logo",
      "empty": "Nessun logo caricato",
      "upload": "Carica logo",
      "change": "Cambia logo",
      "remove": "Rimuovi",
      "hint": "Compare nel contratto PDF, nel preventivo, nella pagina di firma e nella mail del preventivo.",
      "invalid": "Scegli un file immagine",
      "saved": "Logo salvato",
      "removed": "Logo rimosso",
      "upload_error": "Caricamento del logo non riuscito",
      "remove_error": "Rimozione del logo non riuscita"
    }
  },
  "riepilogo": {
    "tabs": {
      "wedding": "Evento",
      "test": "Prova",
      "sopralluogo": "Sopralluogo",
      "client": "Scheda Cliente",
      "costs": "Costi",
      "logistics": "Servizi",
      "contract": "Contratto",
      "collaborators": "Collaboratori",
      "documents": "Documenti",
      "payments": "Pagamenti"
    },
    "wedding_tab_desc": "Data, orario e location dell'evento: sono le informazioni che finiscono anche nell'intestazione del contratto.",
    "test_tab_desc": "Programma la prova trucco e parrucco prima del grande giorno.",
    "sopralluogo_tab_desc": "Programma il sopralluogo alla location prima dell'evento.",
    "client_tab_desc": "Anagrafica completa della sposa: usata per generare il contratto e restare in contatto.",
    "documents_tab_desc": "Carica e organizza documenti utili per questo evento (preventivi, ricevute, moodboard...).",
    "payments": {
      "title": "Pagamenti",
      "title_desc": "Registra acconto e saldo e tieni traccia di quanto resta da incassare.",
      "services": "Servizi",
      "total": "Totale",
      "deposit": "Acconto",
      "balance": "Saldo",
      "paid": "Pagato",
      "collected": "Incassato",
      "to_collect": "Da incassare",
      "note_placeholder": "Nota (es. data, metodo)",
      "save": "Salva pagamenti",
      "saving": "Salvataggio…",
      "saved": "Pagamenti salvati",
      "received": "Incassato",
      "received_on": "Incassato il",
      "paid_at": "Data incasso",
      "method": "Metodo",
      "due_date": "Scadenza",
      "due_on": "Scadenza",
      "overdue": "Saldo scaduto il {{date}}",
      "share_summary": "Invia riepilogo alla cliente",
      "state_received": "ricevuto",
      "state_pending": "da ricevere",
      "save_error": "Salvataggio pagamento non riuscito",
      "methods": {
        "cash": "Contanti",
        "transfer": "Bonifico",
        "card": "Carta",
        "other": "Altro"
      }
    },
    "wedding": {
      "date": "Data evento",
      "time": "Ora",
      "location": "Location",
      "contract_date": "Data contratto",
      "notes": "Note"
    },
    "test": {
      "date": "Data prova",
      "time": "Ora",
      "location": "Location",
      "notes": "Note",
      "photos": "Foto prova"
    },
    "client": {
      "name": "Nome",
      "lastname": "Cognome",
      "address": "Indirizzo",
      "dob": "Data di nascita",
      "pob": "Luogo di nascita",
      "services": "Servizi"
    },
    "costs": {
      "total": "Totale",
      "deposit": "Acconto",
      "balance": "Saldo",
      "travel": "Trasferta",
      "paid": "Pagato",
      "not_paid": "Non pagato"
    },
    "collab_banner": "Stai visualizzando questo matrimonio come collaboratore",
    "organized_by": "organizzato da",
    "wedding_card": "Scheda evento",
    "contract_section": "Contratto",
    "no_contract": "Nessun contratto generato",
    "generate_contract": "Genera Contratto",
    "view": "Visualizza",
    "download": "Scarica",
    "regenerate": "Rigenera",
    "preview_title": "Anteprima contratto",
    "finalize": "Finalizza e genera",
    "cancel_preview": "Annulla",
    "generate_signature": "Genera link firma cliente",
    "link_valid": "Link firma (valido 7 giorni)",
    "copy": "Copia",
    "share_hint": "Condividi via WhatsApp o email",
    "signed_at_prefix": "Firmata il",
    "generate_signed_pdf": "Genera PDF firmato",
    "signed_pdf_done": "PDF firmato generato",
    "hide_history": "▲ Nascondi storico",
    "show_history": "▼ Storico versioni",
    "no_history": "Nessuna versione precedente",
    "signed_badge": "✓ Firmato",
    "contract_name_label": "Nome Contratto",
    "contract_date_label": "Data Contratto",
    "notes_section": "Note",
    "trial_date": "Data Prova",
    "trial_time": "Ora Prova",
    "trial_cost": "Costo prova",
    "travel": {
      "label": "Trasferta",
      "manual_title": "Importo manuale",
      "auto_title": "Calcolo automatico",
      "auto_hint": "Inserisci il costo al km e premi Calcola: sovrascrive l'importo manuale con distanza A/R × €/km. Precompilato con la tua tariffa di default.",
      "total": "totale",
      "per_km": "/km",
      "calculate": "Calcola",
      "calculating": "Calcolo…",
      "breakdown": "≈ {{km}} km A/R × {{rate}} €/km",
      "no_rate": "Distanza {{km}} km A/R. Inserisci un costo al km maggiore di 0 per calcolare l'importo.",
      "no_base": "Imposta prima l'indirizzo base nelle impostazioni contratto",
      "no_location": "Inserisci prima la location dell'evento",
      "error": "Impossibile calcolare la distanza per questo indirizzo"
    },
    "open_maps": "Apri in mappe",
    "trial_location": "Location Prova",
    "sopralluogo_date": "Data Sopralluogo",
    "sopralluogo_time": "Ora Sopralluogo",
    "sopralluogo_location": "Location Sopralluogo",
    "photos_section": "Foto",
    "no_photos": "Nessuna foto caricata",
    "drop_photos": "Trascina le foto o clicca per selezionare",
    "documents_section": "Documenti",
    "no_documents": "Nessun documento caricato",
    "drop_documents": "Trascina i documenti o clicca per selezionare",
    "documents_unit": "documenti",
    "document_name_placeholder": "Nome del documento",
    "document_note_placeholder": "Aggiungi una nota...",
    "uploading": "Caricamento...",
    "logistics_title": "Servizi",
    "logistics_tab_desc": "Servizi scelti, prezzi, trasferta e sconto di questo evento.",
    "services_section": "Servizi",
    "custom_service": {
      "add": "Aggiungi voce fuori listino",
      "name": "Nome della voce",
      "description": "Descrizione (facoltativa)",
      "remove": "Rimuovi voce",
      "badge": "Fuori listino"
    },
    "no_services_profile": "Nessun servizio nel listino",
    "add_from_profile": "aggiungili dal profilo",
    "no_services_selected": "Nessun servizio selezionato",
    "packages_section": "Pacchetti",
    "no_packages_selected": "Nessun pacchetto selezionato",
    "add_custom_package": "+ Aggiungi pacchetto personalizzato",
    "summary_section": "Riepilogo",
    "no_services_packages": "Nessun servizio o pacchetto selezionato",
    "show_prices": "Mostra prezzi singoli nel contratto",
    "show_total": "Mostra totale nel contratto",
    "participants_section": "Clienti",
    "no_participants": "Nessun cliente aggiunto",
    "name_optional": "Nome (opzionale)",
    "notes_placeholder": "Note...",
    "add_participant": "+ Aggiungi",
    "team_tab": "Team & Collaboratori",
    "team_tab_desc": "Assegna il tuo team fisso o invita colleghi a vedere e gestire questo evento con te.",
    "team_status_assigned": "Assegnato",
    "team_status_pending": "In attesa",
    "team_status_accepted": "✓ Confermato",
    "team_status_rejected": "✗ Rifiutato",
    "team_resend": "↺ Reinvia",
    "team_empty": "Nessun membro assegnato",
    "team_add_from": "Aggiungi dal team",
    "contract_tab": "Contratto",
    "contract_tab_desc": "Genera il PDF, gestisci la firma digitale e consulta lo storico delle versioni del contratto.",
    "contract_custom": "Clausole personalizzate per questa sposa",
    "free_text_section": "Testo libero",
    "override_note": "Override per questa sposa: variabili sostituite al momento della generazione PDF",
    "restore_from_profile": "↺ Ripristina da profilo",
    "text_from_profile": "Testo caricato dal profilo",
    "text_from_profile_desc": "Modificalo liberamente, verrà salvato solo per questa sposa.",
    "no_text_configured": "Nessun testo configurato",
    "save_contract_text": "Salva testo contratto",
    "missing": {
      "title": "Per il contratto mancano",
      "add_time": "Aggiungi orario",
      "add_location": "Aggiungi luogo",
      "add_phone": "Aggiungi telefono",
      "add_email": "Aggiungi email"
    },
    "edit_btn": "Modifica",
    "save_btn": "Salva",
    "delete_event": "Elimina evento",
    "upload_action": "Carica",
    "photos_unit": "foto",
    "it_text_prefix": "Testo IT per",
    "en_text_prefix": "Testo EN per",
    "contract_tab_all_note": "Tutti i campi di questa sezione compaiono nel contratto",
    "visibility": {
      "title": "Visibilità sezioni",
      "hint": "Personalizza cosa vedono collaboratori e team SOLO per questo evento. Lascia invariato per usare i default del profilo.",
      "save": "Salva per questo evento",
      "reset": "Ripristina default profilo",
      "collaborators_see": "Cosa vedono i collaboratori",
      "team_see": "Cosa vede il team"
    },
    "in_contract": "nel contratto",
    "add_photo": "Aggiungi",
    "delete_photo": "Elimina foto",
    "edit_document": "Modifica documento",
    "delete_document": "Elimina documento",
    "team_add": "Aggiungi persone",
    "team_pro_lock": "Aggiungi team e collaboratori con il piano Pro.",
    "team_pro_cta": "Passa a Pro",
    "team_group_team": "Team",
    "team_group_collaborators": "Collaboratori",
    "team_picker_empty": "Nessun membro disponibile.",
    "send_for_signature": "Invia per la firma",
    "share_signature_link": "Condividi il link di firma",
    "regenerate_signature_link": "Genera un nuovo link",
    "customize_contract": "Personalizza i testi del contratto",
    "signature_link_error": "Impossibile generare il link di firma",
    "regenerate_signed_title": "Contratto già firmato",
    "regenerate_signed_text": "Questo contratto è già firmato. Rigenerandolo la firma attuale non sarà più valida e servirà una nuova firma della cliente. La versione firmata resta nello storico. Continuare?",
    "discount": {
      "label": "Sconto",
      "description": "Descrizione (facoltativa)",
      "description_placeholder": "Es. Prenotazione anticipata",
      "include_travel": "Applica anche alla trasferta"
    },
    "signature_link_expired_title": "Contratto da rigenerare",
    "signature_link_expired": "Il link di firma è stato annullato perché i dati del contratto sono cambiati: rigenera il contratto e invialo di nuovo.",
    "signature_share_title": "Firma del contratto",
    "signature_share_text": "Ciao {{name}}, ecco il link per leggere e firmare il contratto:",
    "hero": {
      "today": "Oggi",
      "tomorrow": "Domani",
      "in_days": "Tra {{n}} giorni",
      "past": "Concluso",
      "contract_todo": "Contratto da fare",
      "contract_ready": "Contratto pronto",
      "contract_waiting": "In attesa di firma",
      "contract_signed": "Contratto firmato",
      "pay_none": "Nessun importo",
      "pay_done": "Saldato",
      "pay_todo": "Da incassare {{amount}}",
      "pay_overdue": "Saldo scaduto: {{amount}}",
      "team_none": "Nessun collaboratore",
      "team_pending": "{{n}} in attesa",
      "team_ok": "Team: {{n}}",
      "directions": "Indicazioni",
      "call": "Chiama",
      "email": "Email",
      "share": "Condividi",
      "more": "Altro",
      "copied": "Copiato negli appunti"
    },
    "contract_steps": {
      "generate": "Genera",
      "send": "Invia",
      "sign": "Firma",
      "signed_pdf": "PDF firmato"
    },
    "contract_stage": {
      "draft": "Genera il contratto con i dati di questo evento.",
      "ready": "Contratto pronto: invialo alla cliente per la firma online.",
      "sent": "In attesa della firma della cliente. Il link è valido fino al {{expires}}.",
      "signed": "La cliente ha firmato il {{signed}}: genera il PDF firmato.",
      "done": "Contratto firmato e archiviato."
    }
  },
  "feedback": {
    "title": "Aiutaci a migliorare Nyzed",
    "subtitle": "Sei tra le prime a usare Nyzed. La tua opinione vale tantissimo.",
    "nps": "Quanto consiglieresti Nyzed a una collega?",
    "subscription": "Saresti interessata a un abbonamento?",
    "yes": "Sì, mi interessa",
    "no": "No, non mi interessa",
    "price": "Quanto pagheresti al mese?",
    "features": "Quali funzionalità usi di più?",
    "missing": "Cosa vorresti che Nyzed avesse?",
    "submit": "Invia feedback",
    "thanks": "Grazie mille!",
    "already": "Hai già inviato il tuo feedback.",
    "thanks_desc": "Il tuo feedback ci aiuterà a costruire la versione definitiva di Nyzed.",
    "beta_discount": "Come beta tester riceverai uno sconto permanente al lancio ufficiale dell'abbonamento.",
    "back_home": "Torna alla home",
    "nps_hint": "1 = per niente, 10 = assolutamente sì",
    "nps_legend_low": "Per niente",
    "nps_legend_high": "Assolutamente sì",
    "subscription_hint": "Nyzed sarà a pagamento dopo la fase beta",
    "price_label": "Quanto pagheresti al mese?",
    "features_hint": "Seleziona tutte quelle che ti sono utili",
    "missing_hint": "Funzionalità mancanti, miglioramenti, idee libere",
    "missing_placeholder": "Es. notifiche via email, app mobile, integrazione con Google Calendar...",
    "beta_promise_title": "Sconto permanente per i beta tester",
    "beta_promise_desc": "Compilando questo questionario, riceverai uno sconto esclusivo e permanente quando Nyzed lancerà l'abbonamento ufficiale.",
    "update": "Aggiorna feedback"
  },
  "firma": {
    "loading": "Caricamento in corso...",
    "expired_title": "Link scaduto",
    "expired_desc": "Questo link di firma è scaduto. Contatta la tua wedding artist per riceverne uno nuovo.",
    "signed_title": "Contratto firmato",
    "signed_desc": "Hai già firmato questo contratto. Grazie!",
    "error_title": "Link non valido",
    "eyebrow": "Firma contratto",
    "confirm_text": "Firmando questo documento confermi di aver letto e accettato le condizioni del contratto di servizio.",
    "valid_until": "Link valido fino al:",
    "subtotal": "Subtotale",
    "read_contract": "Leggi il contratto",
    "services_title": "Servizi inclusi",
    "total": "Totale",
    "signature_label": "La tua firma",
    "signature_hint": "Disegna qui la tua firma con il dito o il mouse",
    "clear": "↺ Cancella",
    "submit": "Firma e conferma",
    "submitting": "Invio in corso...",
    "legal": "Firmando digitalmente accetti le condizioni del contratto. La firma verrà salvata e associata al tuo nome."
  },
  "novita": {
    "eyebrow": "Nyzed",
    "title": "Novità & Aggiornamenti",
    "subtitle": "Tutte le novità, miglioramenti e correzioni di Nyzed",
    "current_version": "Versione attuale"
  },
  "not_found": {
    "title": "In lavorazione!",
    "message": "Questa pagina è ancora in fase di sviluppo. Torna presto per vedere le novità!",
    "back": "Torna alla Home"
  },
  "crea": {
    "eyebrow": "Nuovo",
    "title": "Aggiungi",
    "title_sub": "evento",
    "services": "Servizi",
    "packages": "Pacchetti",
    "total": "Totale",
    "show_prices": "Mostra prezzi singoli nel contratto",
    "show_total": "Mostra totale nel contratto",
    "contract_section": "Contratto & Note",
    "generate_contract": "Genera contratto",
    "generate_contract_sub": "Il PDF verrà generato automaticamente al salvataggio",
    "generate_contract_tooltip": "Se non hai ancora tutti i dati puoi lasciarlo spento: potrai generare il contratto in qualsiasi momento dalla scheda evento.",
    "contract_hint": "Completa tutti i dati della sposa, data matrimonio e location per abilitare",
    "contract_date": "Data contratto",
    "contract_name": "Nome contratto",
    "contract_fields_tooltip": "Servono per identificare il documento: possono essere diversi dalla data del matrimonio (es. la data in cui firmate il contratto).",
    "contract_name_placeholder": "Es. Contratto Sofia Rossi",
    "notes": "Note",
    "notes_placeholder": "Annotazioni libere...",
    "cancel": "Annulla",
    "submit": "Salva evento →",
    "required": "Campo obbligatorio",
    "bride": {
      "section": "Cliente",
      "name": "Nome",
      "lastname": "Cognome",
      "email": "Email",
      "address": "Indirizzo di residenza",
      "dob": "Data di nascita",
      "pob": "Luogo di nascita",
      "name_placeholder": "Es. Sofia",
      "lastname_placeholder": "Es. Rossi",
      "email_placeholder": "sofia@email.com",
      "address_placeholder": "Via Roma 1, Milano",
      "pob_placeholder": "Es. Roma",
      "phone": "Telefono",
      "phone_placeholder": "Es. 333 123 4567"
    },
    "wedding": {
      "section": "Evento",
      "date": "Data",
      "time": "Ora",
      "location": "Location",
      "test_date": "Data prova",
      "test_time": "Ora prova",
      "test_location": "Location prova",
      "location_placeholder": "Es. Villa Borghese, Roma",
      "test_location_placeholder": "Es. Studio, Milano",
      "test_cost": "Costo prova",
      "test_cost_placeholder": "Es. 80"
    },
    "new_title": "Nuovo evento",
    "optional_hint": "Bastano nome e data. Il resto puoi aggiungerlo ora o più tardi dalla scheda evento.",
    "sections": {
      "client": "Dati per il contratto",
      "trial": "Prova",
      "sopralluogo": "Sopralluogo",
      "services": "Servizi e trasferta"
    },
    "summary": {
      "filled": "{{n}}/{{total}} compilati"
    },
    "cost": "Costo",
    "qty_less": "Diminuisci quantità",
    "qty_more": "Aumenta quantità",
    "travel_pro": "Il calcolo automatico della trasferta è disponibile con il piano Pro o Agency.",
    "listino_panel": {
      "open": "aggiungi una voce",
      "title": "Nuova voce di listino",
      "desc": "La salviamo nel tuo listino e la aggiungiamo a questo evento. Quello che hai scritto nel form resta com'è.",
      "save": "Salva e aggiungi"
    },
    "missing_title": "Per generare il contratto mancano:",
    "missing": {
      "name": "Nome cliente",
      "date": "Data evento",
      "location": "Location",
      "lastname": "Cognome",
      "address": "Indirizzo",
      "dob": "Data di nascita",
      "pob": "Luogo di nascita",
      "services": "Almeno un servizio"
    },
    "create": "Crea evento",
    "saving": "Salvataggio…",
    "missing_confirm_title": "Mancano dati per il contratto",
    "missing_confirm_text": "Per generare il contratto servono: {{list}}. Vuoi completarli o creare l'evento senza contratto?",
    "create_without": "Crea senza contratto",
    "complete_data": "Completa i dati",
    "period": {
      "label": "Periodo indicativo",
      "year": "Anno",
      "any": "Mese o stagione (facoltativo)",
      "hint": "Senza una data precisa il preventivo resta fuori dal calendario. Per generare il contratto serve la data.",
      "no_date": "Data da definire",
      "jan": "Gennaio",
      "feb": "Febbraio",
      "mar": "Marzo",
      "apr": "Aprile",
      "may": "Maggio",
      "jun": "Giugno",
      "jul": "Luglio",
      "aug": "Agosto",
      "sep": "Settembre",
      "oct": "Ottobre",
      "nov": "Novembre",
      "dec": "Dicembre",
      "spring": "Primavera",
      "summer": "Estate",
      "autumn": "Autunno",
      "winter": "Inverno",
      "date_needed": "Imposta la data dell'evento per generare il contratto"
    }
  },
  "changelog_modal": {
    "eyebrow": "Novità",
    "version": "Versione",
    "view_all": "Vedi storico completo",
    "cta": "Ottimo, continua →"
  },
  "beta_modal": {
    "title": "Benvenuta nella versione beta di Nyzed",
    "desc": "Sei tra le prime a usare questa app. Stiamo ancora migliorando tutto: il tuo feedback è prezioso e ci aiuterà a costruire la versione definitiva.",
    "gift_title": "Regalo per i beta tester",
    "gift_desc": "Chi partecipa alla beta riceverà uno sconto permanente sull'abbonamento al lancio ufficiale.",
    "feedback_btn": "Lascia il tuo feedback",
    "skip_btn": "Lo faccio dopo"
  },
  "blocks": {
    "section_title_placeholder": "Titolo sezione",
    "deposit_label": "Acconto (€)",
    "deposit_method_label": "Metodo acconto",
    "cash": "Contanti",
    "transfer": "Bonifico",
    "both": "Entrambi",
    "iban_label": "IBAN",
    "paypal_label": "PayPal (opzionale)",
    "final_when_label": "Quando pagare il saldo",
    "wedding_day_opt": "Giorno dell'evento",
    "days_before_opt": "Giorni prima",
    "how_many_days": "Quanti giorni prima",
    "final_method_label": "Metodo saldo",
    "preview_label": "✦ Anteprima",
    "work_table": "Tavolo da lavoro",
    "natural_light": "Luce naturale",
    "power_outlet": "Presa elettrica",
    "additional_notes": "Note aggiuntive",
    "other_needs_placeholder": "Altre esigenze...",
    "cancellation_deposit_label": "Acconto in caso di cancellazione",
    "refundable": "Rimborsabile",
    "not_refundable": "Non rimborsabile",
    "postponement_label": "In caso di rinvio",
    "transfer_date": "Acconto trasferito alla nuova data",
    "keep_deposit": "Acconto trattenuto",
    "cancellation_notes_placeholder": "Condizioni particolari...",
    "custom_text_label": "Testo della clausola",
    "custom_text_placeholder": "Scrivi qui il testo della clausola...",
    "empty_state": "Nessun blocco ancora. Aggiungine uno qui sotto.",
    "add_block_label": "Aggiungi blocco",
    "add_payment": "Pagamento",
    "add_location": "Location",
    "add_cancellation": "Cancellazione",
    "add_custom": "Nota libera",
    "remove_title": "Rimuovi blocco"
  },
  "common": {
    "load_failed": "Impossibile caricare i dati. Controlla la connessione e riprova.",
    "retry": "Riprova",
    "save": "Salva",
    "cancel": "Annulla",
    "edit": "Modifica",
    "delete": "Elimina",
    "confirm": "Conferma",
    "close": "Chiudi",
    "loading": "Caricamento...",
    "error": "Si è verificato un errore",
    "success": "Operazione completata",
    "caps_lock_on": "Bloc Maiusc attivo",
    "show_password": "Mostra password",
    "hide_password": "Nascondi password"
  },
  "signature_pad": {
    "draw_tab": "Disegna",
    "upload_tab": "Carica PNG",
    "upload_cta": "Scegli un file PNG",
    "upload_remove": "Rimuovi",
    "upload_invalid_type": "Carica un file PNG.",
    "upload_too_large": "Il file è troppo grande (max 5MB)."
  },
  "deposit_toggle": {
    "fixed": "Fisso",
    "percent": "Percentuale"
  },
  "google_signin": {
    "link_confirm_title": "Account già esistente",
    "link_confirm_text": "Esiste già un account Nyzed con questa email. Vuoi collegarlo al tuo account Google?"
  },
  "swal": {
    "error": "Errore",
    "success": "Successo",
    "ok": "Ok",
    "yes": "Sì",
    "delete": "Elimina",
    "generate": "Genera",
    "contract_lang_title": "Lingua del contratto",
    "contract_lang_text": "Scegli la lingua per la generazione del PDF",
    "missing_data": "Dati mancanti",
    "complete_contract_fields": "Per generare il contratto completa questi campi:",
    "download_failed": "Download fallito",
    "contract_open_failed": "Impossibile aprire il contratto",
    "event_created": "Evento creato con successo!",
    "fill_required": "Per favore, compila tutti i campi obbligatori.",
    "load_error": "Errore durante il caricamento.",
    "generic_error": "Si è verificato un errore.",
    "fill_all_required": "Compila tutti i campi richiesti!",
    "failed_captcha": "Verifica captcha fallita",
    "password_mismatch": "Le password non corrispondono!",
    "registration_success": "Registrazione avvenuta con successo!",
    "can_login": "Controlla la tua email per confermare l'account, poi potrai accedere.",
    "oops": "Oops...",
    "registration_error": "Errore durante la registrazione, riprova.",
    "confirm_enable": "Riattivare {{name}}?",
    "confirm_disable": "Disabilitare {{name}}?",
    "user_enabled": "Utente riattivato",
    "user_disabled": "Utente disabilitato",
    "operation_failed": "Operazione fallita",
    "confirm_delete_user": "Eliminare {{name}}?",
    "delete_user_warning": "Verranno eliminati anche tutti i suoi matrimoni. Questa azione è irreversibile.",
    "user_deleted": "Utente eliminato",
    "delete_failed": "Eliminazione fallita",
    "password_min": "La password deve essere di almeno 6 caratteri",
    "password_updated": "Password aggiornata",
    "password_reset_failed": "Reset password fallito",
    "role_updated": "Ruolo aggiornato",
    "subscription_updated": "Abbonamento aggiornato",
    "subscription_update_failed": "Aggiornamento fallito",
    "events_load_error": "Si è verificato un errore durante il caricamento degli eventi.",
    "unauthorized": "Accesso non autorizzato",
    "forbidden": "Non hai i permessi per questa sezione"
  },
  "settings": {
    "tour": {
      "section_title": "Tour & Guida",
      "section_desc": "Rivedi il tour guidato di una sezione: ti portiamo subito sulla pagina interessata.",
      "review": "Rivedi",
      "review_all": "Rivedi tutti i tour",
      "labels": {
        "home": "Tour Home",
        "events": "Tour Lista eventi",
        "event": "Tour Scheda evento",
        "profile": "Tour Profilo"
      },
      "reset_event_msg": "Tour ripristinato, apri un evento dalla lista per rivederlo",
      "reset_all_msg": "Tutti i tour ripristinati"
    },
    "contract_wizard": {
      "section_title": "Configurazione contratto",
      "section_desc": "Rivedi passo passo i dati di default del contratto (studio, pagamento, location, cancellazione, template).",
      "review": "Configura dati contratto"
    },
    "notifications": {
      "banner_title": "Personalizza le tue notifiche",
      "banner_desc": "Scegli quali email ricevere. Puoi modificarle in qualsiasi momento.",
      "title": "Notifiche email",
      "test": "Invia email di prova",
      "test_sent": "Email di prova inviata!",
      "test_error": "Invio non riuscito",
      "items": {
        "contract_signed": {
          "label": "Firma contratto",
          "desc": "Quando il cliente firma il contratto digitale"
        },
        "quote_accepted": {
          "label": "Preventivo accettato",
          "desc": "Quando la cliente accetta un preventivo"
        },
        "event_reminder": {
          "label": "Promemoria evento",
          "desc": "7 giorni prima di ogni evento in programma"
        },
        "collaborator_invite": {
          "label": "Invito collaborazione",
          "desc": "Quando ricevi un invito da un collega"
        },
        "collaborator_response": {
          "label": "Risposta collaborazione",
          "desc": "Quando un collega accetta o rifiuta il tuo invito"
        },
        "deposit_reminder": {
          "label": "Promemoria caparra",
          "desc": "Se la caparra non risulta ancora ricevuta"
        },
        "contract_expiry": {
          "label": "Contratto non firmato",
          "desc": "Se mancano 7 giorni all'evento e il contratto non è firmato"
        },
        "weekly_recap": {
          "label": "Recap settimanale",
          "desc": "Riepilogo degli eventi della settimana, ogni lunedì mattina"
        },
        "app_news": {
          "label": "Novità app",
          "desc": "Aggiornamenti importanti e nuove funzionalità di Nyzed"
        }
      }
    },
    "support": {
      "section_title": "Assistenza",
      "section_desc": "Hai un problema o una domanda? Scrivici in chat.",
      "chat_label": "Chat di supporto",
      "chat_desc": "Rispondiamo di solito entro qualche ora lavorativa.",
      "chat_cta": "Apri la chat"
    },
    "title": "Impostazioni",
    "lang": {
      "title": "Lingua",
      "desc": "Cambia la lingua dell'interfaccia dell'app. I testi che scrivi tu (es. le clausole del contratto) restano nella lingua in cui li hai inseriti."
    },
    "visibility_saved": "Visibilità salvata",
    "visibility_error": "Salvataggio visibilità fallito",
    "account": {
      "title": "Account",
      "desc": "Gestisci l'accesso al tuo account Nyzed.",
      "password_label": "Cambia password",
      "password_desc": "Gestisci la password dal tuo profilo.",
      "go_profile": "Vai al profilo →",
      "delete_label": "Elimina account",
      "delete_desc": "Rimozione definitiva di tutti i dati.",
      "wip": "In costruzione"
    }
  },
  "stats": {
    "title": "Statistiche",
    "total_events": "Eventi totali",
    "events_in_year": "Eventi nel {{year}}",
    "empty": "Ancora nessun evento: le statistiche si riempiono man mano che lavori.",
    "empty_cta": "Crea il primo evento",
    "pro": {
      "title": "Sblocca le statistiche complete",
      "text": "Con il piano Pro vedi l'andamento della tua attività: trasferte, città, fatturato, incassi, stagionalità, tasso di firma e la mappa dei tuoi eventi.",
      "cta": "Passa a Pro"
    },
    "kpi": {
      "avg_value": "Valore medio evento",
      "revenue": "Fatturato stimato",
      "collected": "Incassato",
      "signed": "Contratti firmati",
      "sign_rate": "{{rate}}% degli eventi",
      "busiest": "Mese più intenso"
    },
    "in_year": "nel {{year}}",
    "estimate_year": "stima {{year}}",
    "n_events": "{{n}} eventi",
    "estimate": "stima",
    "charts": {
      "events": "Eventi per mese",
      "revenue": "Fatturato per mese",
      "collected": "Incassato per mese"
    },
    "collected_no_date": "Altri {{amount}} € risultano incassati ma senza data (segnati prima della 3.2.0): non compaiono nel grafico.",
    "travel": {
      "title": "Trasferte",
      "km_year": "km nel {{year}}",
      "km_upcoming": "km da percorrere",
      "cost": "costo trasferte"
    },
    "cities": {
      "title": "Città",
      "others": "+{{n}} altre",
      "empty": "Nessuna città registrata in questo anno."
    },
    "map_title": "Mappa eventi {{year}}"
  },
  "subscription": {
    "title": "Abbonamento",
    "trial_until": "Prova gratuita fino al",
    "renews_on": "Rinnovo il",
    "active_until": "Attivo fino al",
    "no_renew": ", poi non si rinnova",
    "cancel_title": "Disdici abbonamento",
    "cancel_text": "Manterrai l'accesso fino alla fine del periodo già pagato. Confermi?",
    "cancel_confirm": "Disdici",
    "cancel_done": "Disdetta programmata",
    "cancel_error": "Disdetta non riuscita",
    "reactivate": "Riattiva abbonamento",
    "reactivate_done": "Abbonamento riattivato",
    "reactivate_error": "Riattivazione non riuscita",
    "beta_banner": "Siamo in beta: i piani vengono attivati dallo staff. Scegli quello che ti interessa e invia una richiesta, ti contatteremo.",
    "change_plan": "Cambia piano",
    "choose_plan": "Scegli il tuo piano",
    "recommended": "Consigliato",
    "per_month": "/mese",
    "features": {
      "unlimited_events": "Eventi illimitati",
      "pdf_contracts": "Contratti PDF",
      "price_list": "Listino servizi",
      "maps_travel": "Mappe e trasferte",
      "stats": "Statistiche",
      "contract_themes": "Temi del contratto",
      "team": "Gestione team",
      "priority_support": "Supporto prioritario"
    },
    "current_plan": "Piano attuale",
    "switch_to": "Passa a {{plan}}",
    "subscribe": "Abbonati",
    "request_activation": "Richiedi attivazione",
    "note_stripe": "Pagamenti gestiti in modo sicuro tramite Stripe. Puoi disdire quando vuoi.",
    "note_beta": "Nessun pagamento durante la beta: le richieste vengono valutate dallo staff.",
    "status": {
      "trial": "In prova",
      "active": "Attivo",
      "inactive": "Sospeso",
      "cancelled": "Disdetto"
    },
    "checkout_success": "Abbonamento attivato! Grazie.",
    "checkout_cancel_title": "Operazione annullata",
    "checkout_cancel_text": "Il pagamento non è stato completato.",
    "checkout_error": "Impossibile avviare il pagamento",
    "request_title": "Ti interessa il piano {{plan}}?",
    "request_text": "Durante la beta i piani vengono attivati dallo staff. Lascia un messaggio (facoltativo) e ti contatteremo.",
    "request_sent": "Richiesta inviata! Lo staff ti contatterà.",
    "request_error": "Invio richiesta non riuscito"
  },
  "time_picker": {
    "hour": "Ora",
    "minutes": "Minuti"
  },
  "quote": {
    "badge": "Preventivo",
    "filter": "Preventivi",
    "home_todo": "Preventivi in attesa",
    "create_toggle": "È ancora un preventivo",
    "create_toggle_sub": "Non conta tra gli eventi confermati finché la cliente non accetta",
    "create_btn": "Crea preventivo",
    "date_busy": "In questa data hai già un evento confermato: {{name}}",
    "banner": {
      "draft": "Preventivo da inviare alla cliente.",
      "sent": "Preventivo inviato, valido fino al {{date}}. Quando la cliente accetta ricevi una notifica.",
      "expired": "Il link del preventivo è scaduto."
    },
    "send": "Invia preventivo",
    "share_again": "Condividi di nuovo",
    "resend": "Invia di nuovo",
    "confirm": "Segna come confermato",
    "back_to_quote": "Riporta a preventivo",
    "confirmed_msg": "Evento confermato",
    "reverted_msg": "Evento riportato a preventivo",
    "share_title": "Preventivo",
    "share_text": "Ciao {{name}}, ecco il preventivo per il {{date}}:",
    "link_error": "Impossibile creare il link del preventivo",
    "status_error": "Impossibile aggiornare lo stato",
    "confirm_date_needed": "Imposta la data dell'evento prima di confermarlo",
    "date_to_set": "Data da fissare",
    "link_expired_title": "Preventivo da reinviare",
    "link_expired": "Il link del preventivo è stato annullato perché i dati sono cambiati: invialo di nuovo.",
    "notes_toggle": "Mostra le note alla cliente",
    "notes_toggle_sub": "Compaiono nel preventivo e nel riepilogo che le invii",
    "notes_visible": "Visibili alla cliente",
    "disclaimer_toggle": "Avviso sulle variazioni di prezzo",
    "disclaimer_toggle_sub": "Aggiunge al preventivo la nota che in caso di modifiche o aggiunte il prezzo potrà variare",
    "settings": {
      "title": "Preventivi",
      "desc": "Per quanti giorni resta valido il link di un preventivo dopo l'invio.",
      "days": "giorni",
      "saved": "Validità aggiornata"
    },
    "page": {
      "loading": "Caricamento in corso...",
      "eyebrow": "Preventivo",
      "for": "Per {{name}}",
      "trial": "Prova",
      "inspection": "Sopralluogo",
      "travel": "Trasferta",
      "subtotal": "Subtotale",
      "discount": "Sconto",
      "total": "Totale",
      "deposit": "Acconto alla conferma",
      "valid_until": "Preventivo valido fino al",
      "accept": "Accetto il preventivo",
      "accepting": "Invio in corso...",
      "accept_note": "Accettando confermi la data e i servizi indicati. {{name}} ti contatterà per i prossimi passi.",
      "accepted_title": "Preventivo accettato",
      "accepted_desc": "Grazie! La conferma è stata inviata.",
      "expired_title": "Preventivo scaduto",
      "expired_desc": "Questo preventivo non è più valido. Chiedi un nuovo link.",
      "error_title": "Link non valido",
      "notes": "Note",
      "price_disclaimer": "Il preventivo si riferisce ai servizi indicati. In caso di modifiche o aggiunte il prezzo potrà variare."
    },
    "mail": {
      "open": "Copia mail",
      "title": "Mail del preventivo",
      "include_link": "Includi il link per accettare online",
      "include_link_sub": "Se spento la mail contiene solo le informazioni: la cliente non potrà accettare online",
      "copy": "Copia mail",
      "copied": "Mail copiata: incollala nel tuo programma di posta",
      "copy_error": "Copia non riuscita",
      "greeting": "Ciao {{name}},",
      "intro": "ti invio il preventivo per il {{date}}.",
      "cta": "Accetta il preventivo online",
      "closing": "Resto a disposizione per qualsiasi dubbio. A presto!",
      "language": "Lingua della mail",
      "validity": "Validità del link",
      "validity_days": "Giorni",
      "validity_until": "Fino al",
      "validity_hint": "Cambiandola si crea un nuovo link: quello precedente smette di funzionare",
      "days_confirm_title": "Il link già inviato non funzionerà più",
      "days_confirm_text": "Cambiando la validità si crea un nuovo link: quello già inviato alla cliente smetterà di funzionare e dovrai mandare quello nuovo.",
      "days_confirm": "Crea nuovo link"
    },
    "variants": {
      "add_first": "Aggiungi una proposta alternativa",
      "add": "Aggiungi proposta",
      "default_name": "Proposta {{n}}",
      "untitled": "Senza nome",
      "name": "Nome della proposta",
      "note": "Nota per la cliente (facoltativa)",
      "remove": "Elimina proposta",
      "remove_title": "Eliminare la proposta?",
      "remove_text": "\"{{name}}\" e i suoi prezzi verranno tolti dal preventivo.",
      "hint": "Prova (scheda Evento) e acconto (scheda Pagamenti) seguono la proposta selezionata.",
      "choose": "Scelgo questa",
      "choose_title": "Scegli una proposta",
      "chosen_named": "Hai scelto \"{{name}}\".",
      "summary": "{{count}} proposte, {{range}} · modifica in Servizi"
    }
  },
  "landing": {
    "nav_cta": "Entra in lista",
    "hero": {
      "eyebrow": "In arrivo",
      "title_1": "Nyzed semplifica",
      "title_2": "ogni tuo evento.",
      "lead": "Clienti, preventivi, contratti, calendario e incassi: tutto in un unico posto. Il gestionale per i professionisti beauty che lavorano su eventi. Stiamo per aprire le porte."
    },
    "form": {
      "placeholder": "La tua email",
      "submit": "Avvisami per prima",
      "sending": "Un attimo...",
      "profession": "Di cosa ti occupi?",
      "prof_makeup": "Makeup",
      "prof_hair": "Hair",
      "prof_both": "Entrambi",
      "prof_other": "Altro",
      "note": "Una sola mail, quando apriamo. Niente spam.",
      "error_email": "Controlla l'indirizzo email.",
      "error_captcha": "Verifica di sicurezza in corso, riprova tra un attimo.",
      "error_generic": "Qualcosa non ha funzionato, riprova tra poco."
    },
    "done": {
      "title": "Sei in lista!",
      "text": "Ti abbiamo mandato una mail di conferma. Appena apriamo, lo saprai prima di tutti.",
      "share": "Copia il link e dillo a una collega",
      "copied": "Link copiato"
    },
    "ticker": {
      "events": "Eventi",
      "quote": "Preventivi",
      "contract": "Firma online",
      "calendar": "Calendario",
      "money": "Acconti e saldi",
      "team": "Team",
      "pricelist": "Listino",
      "stats": "Statistiche"
    },
    "features": {
      "kicker": "Cosa c'è dentro",
      "title": "Tutto l'evento, un posto solo",
      "lead": "Tutto quello che oggi tieni tra chat, fogli e quaderni, in un posto solo.",
      "events_title": "Ogni evento in una scheda",
      "events_text": "Cliente, data, location, servizi, team e note: tutto insieme, sempre a portata di mano.",
      "quote_title": "Preventivi con un link",
      "quote_text": "Componi il preventivo dal tuo listino, invialo e la cliente lo accetta dal telefono.",
      "contract_title": "Contratti con firma online",
      "contract_text": "Il contratto nasce dai dati dell'evento e si firma a distanza, senza stampare nulla.",
      "calendar_title": "Calendario con meteo",
      "calendar_text": "A colpo d'occhio le date impegnate e che tempo farà il giorno dell'evento.",
      "money_title": "Acconti e saldi sotto controllo",
      "money_text": "Sai sempre cosa hai incassato e cosa manca, evento per evento.",
      "team_title": "Il tuo team, coordinato",
      "team_text": "Assegna chi collabora con te agli eventi: ognuno vede solo ciò che gli serve."
    },
    "peek": {
      "kicker": "Anteprima",
      "title": "Uno sguardo dentro",
      "lead": "Qualcosa te lo mostriamo adesso. Il resto lo scopri al lancio.",
      "veil": "Lo scopri al lancio",
      "shot_1": "La giornata dell'evento",
      "shot_2": "Il preventivo con link",
      "shot_3": "Il calendario"
    },
    "faq": {
      "kicker": "Domande",
      "title": "Prima che tu lo chieda",
      "when_q": "Quando apre Nyzed?",
      "when_a": "Stiamo rifinendo gli ultimi dettagli e non abbiamo ancora una data da annunciare. Chi è in lista la riceve via mail prima di tutti.",
      "when_a_soon": "Stiamo rifinendo gli ultimi dettagli e non abbiamo ancora una data da annunciare. Torna a trovarci: la leggerai qui.",
      "who_q": "Per chi è pensato?",
      "who_a": "Per makeup artist, hairstylist e professionisti beauty che lavorano su eventi di ogni tipo, in proprio o con un team.",
      "price_q": "Quanto costerà?",
      "price_a": "Piani e prezzi li annunceremo insieme al lancio. Iscriverti alla lista è gratuito e non ti impegna a nulla.",
      "price_a_soon": "Piani e prezzi li annunceremo insieme al lancio.",
      "mobile_q": "Funziona dal telefono?",
      "mobile_a": "Sì. Nyzed si usa dal browser, su telefono, tablet e computer, senza installare nulla.",
      "email_q": "Cosa fate con la mia email?",
      "email_a": "La usiamo solo per avvisarti dell'apertura. Puoi chiederci di cancellarla quando vuoi scrivendo a {{email}}."
    },
    "final": {
      "title": "Il posto in prima fila è tuo",
      "text_soon": "Stiamo per aprire le porte. Torna a trovarci presto.",
      "text": "Lascia la tua email: ti scriviamo appena si apre."
    },
    "footer": {
      "privacy": "Privacy",
      "cookie": "Cookie",
      "contact": "Contatti"
    },
    "mock": {
      "event": "Evento",
      "date": "14 giugno",
      "s1": "Trucco",
      "s2": "Acconciatura",
      "s3": "Prova trucco e capelli",
      "total": "Totale",
      "signed": "Contratto firmato",
      "quote_ok": "Preventivo accettato",
      "now": "Adesso",
      "deposit": "Acconto ricevuto",
      "day": "Il giorno dell'evento",
      "t3": "Secondo look",
      "t4": "Ritocco finale",
      "quote": "Preventivo",
      "accept": "Accetta il preventivo",
      "month": "Giugno"
    }
  }
}
